export const textOverflow = (width) => `
    max-width: ${width ? `${width}px` : "unset"};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
